import { createError, showError, useCookie, useRuntimeConfig } from "nuxt/app";

export default async function customFetch<T>(
  url: string,
  options: Record<string, unknown> = { method: "GET" }
): Promise<T> {
  const config = useRuntimeConfig();
  const locale = useCookie("locale").value || config.public.defaultLocale;
  const currency = useCookie("currency").value || config.public.defaultCurrency;

  // Define headers
  const headers = {
    "X-CLIENT-ID": config.public.xClientId,
    Accept: "application/json",
    "Accept-Language": locale,
    "Sec-Fetch-Dest": "empty",
    "Sec-Fetch-Mode": "cors",
    "Sec-Fetch-Site": "same-site",
    "Accept-Currency": currency,
  } as Record<string, string>;

  // Base URL
  const baseURL = config.public.apiBaseUrl!.toString();

  // Construct the full URL
  const fullURL = baseURL?.endsWith("/") ? baseURL + url : baseURL + "/" + url;

  try {
    // Use $fetch with caching
    const response: any = await $fetch<T>(fullURL, {
      ...options,
      headers,
      cache: "force-cache",
    });

    return response.data;
  } catch (error: any) {
    // Handle errors appropriately
    showError(error);
    throw createError({
      message: `API request failed: ${error.message}`,
      statusCode: error.statusCode || 500,
    });
  }
}
